import { Component, Input } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';
import { BasketFreeDeliveryNoticeComponent } from '../free-delivery-notice/basket-free-delivery-notice.component';

export interface IFreeShippingBlockContent extends NICmsContentComponent.IData {
    backgroundColor?: string;
    textColor?: string;
}

/**
 * Component definition
 */
@Component({
    selector: 'free-shipping-block',
    templateUrl: './free-shipping-block.html',
    standalone: true,
    imports: [BasketFreeDeliveryNoticeComponent]
})
@ICmsComponent<FreeShippingBlockComponent>({
    id: 'free-shipping-block',
    block: {
        url: 'free-shipping-block'
    },
    onDemandOnly: true,
    name: 'Basket Free Shipping Block',
    description: 'Content block used in the minibasket',
    fields: [
        <NICmsContentField.IField>{
            key: 'backgroundColor',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Background Color',
            colorPreview: true
        },
        <NICmsContentField.IField>{
            key: 'textColor',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Text Color',
            colorPreview: true
        }
    ]
})
export class FreeShippingBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IFreeShippingBlockContent;

    @Input()
    isBasketView = false;
}
